// Числови формати, общи за целия склад. Копията по листовете (`parseDecimal`,
// `formatMoney` в *Shared файловете) се привеждат тук при всяка задача, която
// ги докосва.

// Закръгляне с половинката НАГОРЕ по десетичния запис (както бекендът —
// ROUND_HALF_UP): 1.005 → 1.01, а не 1.00, както би дал `toFixed` върху
// двоичното 1.00499…. Шумът на плаващата запетая се маха, преди да се реже.
export const roundHalfUp = (value: number, decimals: number): number => {
  const factor = 10 ** decimals;
  const scaled = Number((Math.abs(value) * factor).toFixed(6));
  return (Math.sign(value) * Math.round(scaled)) / factor;
};
// Пари — до стотинка.
export const roundMoney = (value: number): number => roundHalfUp(value, 2);

// Ед. ЦЕНАТА не е сума и НЕ се реже на 2 знака: колоната в базата е
// `Numeric(13,5)`. При доставка сумата на реда е въведената, а цената се
// извежда от нея — 2500 бр за 2.10 € дават 0.00084; с 4 знака ставаше 0.0008 и
// FIFO себестойността на същите 2500 бр излизаше 2.00.
// Показваме 2 знака, когато толкова стигат, иначе колкото носят стойност (до 5):
// 1.50 · 0.1625 · 0.00084. `Number(…)` — стойността идва от BE и при празно
// поле не бива да гърми.
export const UNIT_PRICE_DECIMALS = 5;
export const roundUnitPrice = (value: number): number =>
  roundHalfUp(value, UNIT_PRICE_DECIMALS);
export const formatUnitPrice = (value: number) => {
  const exact = roundUnitPrice(Number(value ?? 0));
  const twoDigits = exact.toFixed(2);
  if (Number(twoDigits) === exact) return twoDigits;
  return exact.toFixed(UNIT_PRICE_DECIMALS).replace(/0+$/, "");
};

// Сума с десетична ТОЧКА и групирани хиляди („1 234.56") — парите в модула.
export const formatMoney = (value: number) =>
  Number(value ?? 0)
    .toLocaleString("bg-BG", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    .replace(",", ".");

// Число от поле, което приема и запетая, и точка; празно/невалидно → 0.
export const parseDecimal = (raw: unknown): number => {
  const value = parseFloat(
    String(raw ?? "")
      .replace(/\s/g, "")
      .replace(",", "."),
  );
  return Number.isNaN(value) ? 0 : value;
};

// Количество за поле със ЗАПЕТАЯ и точно `decimals` знака, без групиране.
export const formatQtyInput = (value: number, decimals = 3) =>
  value.toFixed(decimals).replace(".", ",");
